import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Note } from "./note.model";

export class NoteApiFacade extends RestrictedAccountObjectApiFacade<Note> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Note> {
        return this.GET(`/accounts/${accountId}/notes/${id}`, options)
            .map(object => new Note(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Note>> {
        return this.CGET(`/accounts/${accountId}/notes`, options)
            .map(objects => objects.map(object => new Note(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.api-facade.ts